import script from "./txt_modes-set.vue?vue&type=script&setup=true&lang=js"
export * from "./txt_modes-set.vue?vue&type=script&setup=true&lang=js"

import "./txt_modes-set.vue?vue&type=style&index=0&id=568bd3ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568bd3ae"]])

export default __exports__